import { Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { InspirationSectionHeader } from "web_myplann/Inspiration/Components/InspirationSectionHeader";

type Props = {
	title: ReactNode;
	rightAction?: ReactNode;
	gap?: number;
	children: ReactNode;
};

export const InspirationSection: FC<Props> = ({
	title,
	rightAction,
	gap,
	children,
}) => {
	const theme = useTheme();

	return (
		<>
			<InspirationSectionHeader title={title} rightAction={rightAction} />
			<Stack
				bgcolor={theme.palette.background.paper}
				px={1.6}
				py={1.6}
				gap={gap}
			>
				{children}
			</Stack>
		</>
	);
};
